import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { PurchaseCondition } from '@retail/calculus/types';
import { CalculusInfoRow } from './CalculusInfoRow';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { CalculusAreaAccordionDetails } from './CalculusAreaAccordionDetails';

interface Props {
  purchaseCondition?: PurchaseCondition;
  purchasePrice?: number;
  openEditDialog?: () => void;
}

export function PurchaseConditionAccordion({
  purchaseCondition,
  purchasePrice,
  openEditDialog,
}: Props) {
  const t = useCalculusTFunction();
  return (
    <Accordion>
      <AccordionSummary>
        <CalculusInfoRow
          description={t('calculus.prices.purchasePrice')}
          price={purchasePrice}
          condition={
            <Typography pl={1} color="text.secondary" variant="body2">
              {purchaseCondition?.agreementText ?? '-'}
            </Typography>
          }
          onEditCondition={openEditDialog ? { onEdit: openEditDialog } : undefined}
        />
      </AccordionSummary>
      <AccordionDetails>
        {purchaseCondition ? (
          <CalculusAreaAccordionDetails
            bindingType={purchaseCondition.bindingType}
            conditionValueDesc={t('calculus.agreementId')}
            conditionValue={
              <Typography variant="subtitle2">{purchaseCondition.supplierAgreementId}</Typography>
            }
            validFrom={purchaseCondition.validFrom}
            validTo={purchaseCondition.validTo}
          />
        ) : (
          <Typography variant="body2" sx={{ pl: 2 }}>
            {t('calculus.noPurchaseCondition')}
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
